import { render, staticRenderFns } from "./MagezineInfo.vue?vue&type=template&id=467a9603&"
import script from "./MagezineInfo.vue?vue&type=script&lang=js&"
export * from "./MagezineInfo.vue?vue&type=script&lang=js&"
import style0 from "./MagezineInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports